import { BuildingOfficePlusIcon } from "components/ui/building-office-plus-icon";
import { PrimaryButton } from "components/ui/primary-button";
import { useCreateReferenceBusinessMutation } from "generated/graphql";
import React, { useCallback } from "react";
import { navigate } from "store/actions";
import { useRegionId } from "store/selectors/hooks";

export const AddNewOrganizationButton = () => {
    const createReferenceBusinessMutation = useCreateReferenceBusinessMutation();

    const regionId = useRegionId();

    const handleAddOrganization = useCallback(
        async (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
            e.preventDefault();
            const response = await createReferenceBusinessMutation.mutateAsync({
                regionId,
            });

            if (response?.createReferenceBusiness?.id) {
                navigate(
                    `/references/organizations/show/${response.createReferenceBusiness.id}`,
                );
            }
        },
        [createReferenceBusinessMutation, regionId],
    );

    return (
        <PrimaryButton onClick={handleAddOrganization}>
            <div className="flex items-center md:space-x-2">
                <BuildingOfficePlusIcon className="w-5 h-5" />
                <span className="text-sm max-md:hidden">New organization</span>
            </div>
        </PrimaryButton>
    );
};
